const addWxRouter = [
  {
    path: '/add-course-wx',
    name: 'add-course-wx',
    component: () => import('@/views/add-wx/add-course-wx/index.vue'),
    meta: {
      title: '领取成功',
    }
  },
];
export default addWxRouter;